import { createContext } from 'react'

/**
 * Context containing the current session's org membership.
 */
export const MembershipContext = createContext()

export default MembershipContext
